import React from 'react';

import style from './articles.module.scss';

export const Articles = () => {
    return (
        <div className={style.articlesContainer}>
            <div className={style.articlesTitle}>
                <div className={style.articlesTitleText}>Popular O-Ring Materials</div>
            </div>
            <div className={style.articles}>
                <article className={style.article}>
                    <div className={style.articleTitle}>Perfluoroelastomers (FFKM)</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: 5°F (-15°C) - 550°F (287°C) <br />
                            Specialty: -50°F (-45°C) - 650°F (343°C) <br />
                        </div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>
                                    Known for its chemical resistance, heat resistance, and high-performance
                                    capabilities.
                                </li>
                                <li className={style.li}>
                                    The typical choice for many applications thanks to its versatility.
                                </li>
                                <li className={style.li}>Usually outlasts inferior alternatives.</li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Liquid chromatography equipment</li>
                                <li className={style.li}>Mechanical seals</li>
                                <li className={style.li}>Painting equipment</li>
                                <li className={style.li}>Pumps & valves</li>
                                <li className={style.li}>Aerospace fuels, Skydrol & oils</li>
                                <li className={style.li}>Chemical sprayers, injectors, & reactors</li>
                                <li className={style.li}>Connectors, controls & filters</li>
                                <li className={style.li}>Petro-chem equipment, sour gas</li>
                                <li className={style.li}>Ink handling & spraying equipment</li>
                                <li className={style.li}>Inorganic & organic acids & alkine</li>
                                <li className={style.li}>Ketones, esters, ethers, aldehydes</li>
                                <li className={style.li}>Etch</li>
                                <li className={style.li}>Strip</li>
                                <li className={style.li}>LPCVD</li>
                                <li className={style.li}>Litho/Track</li>
                                <li className={style.li}>ECP</li>
                                <li className={style.li}>Exhaust valves</li>
                            </ul>
                        </div>
                    </div>
                </article>

                <article className={style.article}>
                    <div className={style.articleTitle}>Polytetrafluoroethylene (PTFE)</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: -250°F (-156°C) - 450°F (232°C) <br />
                            Specialty: -300°F (-184°C) - 500°F (260°C) <br />
                        </div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>
                                    A hard plastic that is unaffected by all known acids, alkalis, and solvents allowing
                                    for maximum chemical
                                </li>
                                resistance.
                                <li className={style.li}>
                                    Low coefficient of friction, making it an excellent nonstick option.
                                </li>
                                <li className={style.li}>
                                    Offers a very wide temperature range, from -329°F (-200°C) to 482°F (250°C).
                                </li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Medical devices</li>
                                <li className={style.li}>Coatings</li>
                                <li className={style.li}>Pest control</li>
                                <li className={style.li}>Aerospace</li>
                                <li className={style.li}>Automotive manufacturing</li>
                            </ul>
                        </div>
                    </div>
                </article>

                <article className={style.article}>
                    <div className={style.articleTitle}>Ethylene Propylene (EPDM)</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: -65°F (-53°C) - 300°F (148°C) <br />
                            Specialty: -65°F (-53°C) - 300°F (148°C) <br />
                        </div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>
                                    An extremely durable copolymer that offers some of the best cold-temperature
                                    resistance.
                                </li>
                                <li className={style.li}>Excellent resistance to ozone, sunlight, and weathering.</li>
                                <li className={style.li}>Highly resistant to tears, abrasion, and steam.</li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Weatherproofing</li>
                                <li className={style.li}>Roofing</li>
                                <li className={style.li}>Windows</li>
                                <li className={style.li}>Doors</li>
                                <li className={style.li}>Cell towers</li>
                                <li className={style.li}>Other outdoor applications</li>
                            </ul>
                        </div>
                    </div>
                </article>

                <article className={style.article}>
                    <div className={style.articleTitle}>Nitrile Butadiene Rubber (NBR)</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: -35°F (-35°C) - 250°F (121°C) <br />
                            Specialty: -65°F (-54°C) - 275°F (135°C) <br />
                        </div>

                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>One of the most popular elastomers on the market.</li>
                                <li className={style.li}>
                                    Common in many applications due to its low cost and comprehensive benefits.
                                </li>
                                <li className={style.li}>
                                    Can be a potential solution for harsh environments, such as extremely abrasive
                                    applications.
                                </li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Fuel systems</li>
                                <li className={style.li}>Oil seals</li>
                                <li className={style.li}>Transmission systems</li>
                                <li className={style.li}>Hydraulic and pneumatic seals</li>
                                <li className={style.li}>Drilling equipment</li>
                            </ul>
                        </div>
                    </div>
                </article>

                <article className={style.article}>
                    <div className={style.articleTitle}>FKM</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: -15°F (-26°C) - 437°F (225°C) <br />
                            Specialty: -54°F (-54°C) - 437°F (225°C) <br />
                        </div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>
                                    A widely used option in almost every industry, but especially where reliability is
                                    necessary.
                                </li>
                                <li className={style.li}>Known for its durability and endurance.</li>
                                <li className={style.li}>
                                    Offers exceptional resistance to harsh chemicals and high temperatures.
                                </li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Fuel systems</li>
                                <li className={style.li}>Engine seals</li>
                                <li className={style.li}>Gaskets</li>
                                <li className={style.li}>Pumps</li>
                                <li className={style.li}>Valves</li>
                                <li className={style.li}>Compressors</li>
                                <li className={style.li}>Gearboxes</li>
                                <li className={style.li}>Heavy machinery seals</li>
                            </ul>
                        </div>
                    </div>
                </article>

                <article className={style.article}>
                    <div className={style.articleTitle}>Silicone</div>
                    <div className={style.articleContent}>
                        <div className={style.articleSubTitle}>Temperature Range</div>
                        <div className={style.subTitleContent}>
                            Standard: -65°F (-53°C) - 400°F (204°C) <br />
                            Specialty: -100°F (37°C) - 500°F (260°C) <br />
                        </div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>
                                    An excellent option for high temperatures and static environments.
                                </li>
                                <li className={style.li}>
                                    It is used for a wide range of temperatures and excels in dry heat.
                                </li>
                                <li className={style.li}>Stands up well to sunlight, ozone, and weathering.</li>
                            </ul>
                        </div>

                        <div className={style.articleSubTitle}>Common Applications</div>
                        <div className={style.subTitleContent}>
                            <ul className={style.ul}>
                                <li className={style.li}>Engines</li>
                                <li className={style.li}>Fuel systems</li>
                                <li className={style.li}>Transmissions</li>
                                <li className={style.li}>Hydraulic systems</li>
                                <li className={style.li}>Cabin pressure systems</li>
                                <li className={style.li}>Food and beverage manufacturers</li>
                                <li className={style.li}>Electronic enclosures</li>
                            </ul>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
};
